const { CarouselElement } = window.BAO.Carousel
const { useScrollbar, useStartAtSlide } = window.BAO.Carousel.plugins

export class ArticleCarousel extends CarouselElement {
  static get requiredElements () {
    return ['slider', 'slide']
  }

  static get requiredExternalElements () {
    return ['scrollbar']
  }

  /** @returns {KeenSliderOptions} */
  get options () {
    return {
      slides: {
        perView: '1',
        spacing: 10,
        origin: 'center',
      },
      loop: true,
      breakpoints: {
        '(min-width: 768px)': {
          disabled: true,
        },
      },
    }
  }

  /** @returns {KeenSliderPlugin[]} */
  get plugins () {
    return [
      useScrollbar(this.externalEls?.scrollbar?.element),
      useStartAtSlide(1),
    ]
  }
}

customElements.define('article-carousel', ArticleCarousel)
